( function( global, $ ) {
    "use strict";

    $('body').on('app.ready', function() {
        if ($('[header]')) {
            var $overlay = $('<div>', {'class': 'overlay is-visible'});

            $overlay.on('click', function(event) {
                event.preventDefault();
                var $header = $('[header]');
                $header.removeClass('is-open');
                $(this).removeClass('is-visible');
            });

            $('[header]').on('click', '.hamburger-btn', function(event) {
                event.preventDefault();
                var hasOverlay = false;
                var $header = $(this).closest('[header]');
                $header.toggleClass('is-open');
                if (hasOverlay) return;
                $overlay.addClass('is-visible');
                $header.before($overlay);
                hasOverlay = true;
            });
        }
    });

}( window.groots, jQuery ));
